(function () {
  'use strict';

  angular.module('app.facebookPostOverview', ['ui.router'])

    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('home.facebookPostOverview', {
          requireLogin: true,
          url: 'facebookPostOverview/:url/:relativepath',
          templateUrl: 'app/facebookPostOverview/facebookPostOverview.html?app_v=deployDate',
          scope: {},
          data: { 
            authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
            navMarker: ['facebookPostOverview', 'index']
          },
          controller: 'facebookPostOverviewCtrl',
          controllerAs: 'vm',
          params: {
              url: null,
              relativepath: null
          }
        })
    }]);
})();